/**
 * @flow
 * @format
 */

import _FieldTypeInput from './FieldTypeInput';

export default _FieldTypeInput;



// WEBPACK FOOTER //
// ./src/components/FieldTypeInput/index.js